import React from 'react';
import { Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UIButton from 'components/ui/UIButton';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { feedbackActions } from 'features/feedback/store/feedback.slice';

const SubmitSuccess: React.FC = () => {
  const dispatch = useAppDispatch();
  const submittedType = useAppSelector((s) => s.feedback.submittedType);
  const isIdea = submittedType === 'IDEA';

  return (
    <Box sx={{ textAlign: 'center', py: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
      <Box sx={{ width: 78, height: 78, borderRadius: '50%', display: 'grid', placeItems: 'center', background: 'rgba(39,204,188,.16)' }}>
        <CheckCircleIcon sx={{ fontSize: 46, color: '#12a596' }} />
      </Box>
      <Box sx={{ fontSize: 24, fontWeight: 800 }}>Дякуємо!</Box>
      <Box sx={{ fontSize: 14, color: '#7A7F88', maxWidth: 320 }}>
        {isIdea
          ? 'Ідею опубліковано на дошці — інші вже можуть голосувати.'
          : 'Ми розглянемо це найближчим часом. Стежити за статусом можна в «Моїх зверненнях».'}
      </Box>
      <UIButton variant="contained" onClick={() => dispatch(feedbackActions.closeDrawer())} sx={{ mt: 1 }}>
        Готово
      </UIButton>
    </Box>
  );
};

export default SubmitSuccess;
